import "./src/js/main.js"